import React from "react";

export default function ColorFrame33({ fill, frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          fill="#BDD0FB"
          d="M153.609 20.009a.93.93 0 00-.93-.93h-27.454V96.32c0 6.425 5.208 11.633 11.633 11.633h5.118c6.425 0 11.633-5.208 11.633-11.633V20.01z"
        ></path>
        <path
          fill="#BDD0FB"
          d="M88 77.242c0-26.213 21.249-47.462 47.462-47.462h5.118c26.213 0 47.462 21.25 47.462 47.462v186.125c0 6.425-5.208 11.633-11.633 11.633H99.633C93.208 275 88 269.792 88 263.367V77.242z"
        ></path>
        <mask
          id="mask0_2262_163293"
          style={{ maskType: "alpha" }}
          width="101"
          height="246"
          x="88"
          y="29"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#BDD0FB"
            d="M88 77.242c0-26.213 21.249-47.462 47.462-47.462h5.118c26.213 0 47.462 21.25 47.462 47.462v186.125c0 6.425-5.208 11.633-11.633 11.633H99.633C93.208 275 88 269.792 88 263.367V77.242z"
          ></path>
        </mask>
        <g mask="url(#mask0_2262_163293)">
          <path
            fill={fill}
            d="M9.044 70.802H280.514V234.32299999999998H9.044z"
          ></path>
        </g>
        <path
          fill={fill}
          d="M157.332 7.805C157.827 3.653 154.583 0 150.401 0h-23.049c-4.292 0-7.567 3.836-6.894 8.075l1.109 6.98a6.98 6.98 0 006.894 5.884h21.109a6.98 6.98 0 006.93-6.154l.832-6.98z"
        ></path>
        <circle
          cx="139"
          cy="152"
          r="72.159"
          fill="#fff"
          stroke={fill}
          strokeWidth="5.682"
        ></circle>
        {children}
      </g>
    </svg>
  );
}
